// eslint-disable-next-line max-len
/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
import './HtmlElement.scss';

import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

export const blockTagsList = [
  'address',
  'article',
  'aside',
  'blockquote',
  'div',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'li',
  'main',
  'nav',
  'ol',
  'p',
  'section',
  'table',
  'tfoot',
  'ul',
];

export const textTagsList = [
  'b',
  'big',
  'cite',
  'em',
  'i',
  'q',
  'label',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
];

/* eslint-disable react/jsx-props-no-spreading */
const HtmlElement = ({
  children,
  className,
  decoration,
  font,
  htmlFor,
  id,
  letterSpacing,
  lineHeight,
  // eslint-disable-next-line react/prop-types
  onClick,
  size,
  tag: Tag,
  textAlign,
  textTransform,
  title,
  weight,
}) => {
  const classNames = useMemo(
    () =>
      [
        'html-element',
        `html-element--decoration-${decoration}`,
        `html-element--font-${font}`,
        `html-element--letter-spacing-${letterSpacing}`,
        `html-element--line-height-${lineHeight}`,
        `html-element--size-${size}`,
        textAlign ? `html-element--text-align-${textAlign}` : '',
        `html-element--text-transform-${textTransform}`,
        `html-element--weight-${weight}`,
        className,
      ]
        .filter((val) => val)
        .join(' '),
    [
      className,
      decoration,
      font,
      letterSpacing,
      lineHeight,
      size,
      textAlign,
      textTransform,
      weight,
    ],
  );

  const conditionalProps = useMemo(
    () => ({
      ...(id ? { id } : {}),
    }),
    [id],
  );

  return htmlFor ? (
    <label
      className={classNames}
      {...conditionalProps}
      title={title}
      htmlFor={htmlFor}
      onClick={onClick}
    >
      {children}
    </label>
  ) : (
    <Tag className={classNames} {...conditionalProps} onClick={onClick}>
      {children}
    </Tag>
  );
};

HtmlElement.defaultProps = {
  children: null,
  className: '',
  decoration: 'none',
  font: 'default',
  htmlFor: '',
  id: '',
  letterSpacing: 'normal',
  lineHeight: 'default',
  // eslint-disable-next-line react/default-props-match-prop-types
  onClick: () => {},
  size: 'medium',
  tag: 'p',
  textAlign: 'left',
  textTransform: 'none',
  title: '',
  weight: 'normal',
};

HtmlElement.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  decoration: PropTypes.oneOf(['none', 'underline']),
  font: PropTypes.oneOf(['default', 'primary', 'secondary']),
  htmlFor: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  letterSpacing: PropTypes.oneOf(['small', 'normal', 'medium', 'large']),
  lineHeight: PropTypes.oneOf(['small', 'default', 'large']),

  size: PropTypes.oneOf(['xx-small', 'x-small', 'small', 'medium', 'large']),

  tag: PropTypes.string,
  textAlign: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
  textTransform: PropTypes.oneOf([
    'none',
    'lowercase',
    'uppercase',
    'capitalize',
  ]),
  title: PropTypes.string,
  weight: PropTypes.oneOf(['light', 'normal', 'bold', 'extrabold']),
};

export default HtmlElement;
